import { render } from "./TheList.vue?vue&type=template&id=70dc426c&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"

import "./TheList.vue?vue&type=style&index=0&id=70dc426c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dc426c"]])

export default __exports__